import { request } from './client';
import type {
  AnalyzeThreadToneRequest,
  ThreadAccountProfileResponse,
  ThreadAccountProfileUpdateRequest,
} from './types';

export function updateProfile(
  id: number,
  payload: ThreadAccountProfileUpdateRequest
) {
  return request<ThreadAccountProfileResponse>(
    `/api/thread-account-profiles/update/id/${id}`,
    { method: 'PUT', body: payload }
  );
}

export function analyzeThreadTone(id: number, payload: AnalyzeThreadToneRequest) {
  return request<ThreadAccountProfileResponse>(
    `/api/thread-account-profiles/analyze-thread-tone/id/${id}`,
    { method: 'POST', body: payload }
  );
}
